import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";

export class PhotoSwipeGallery {
  #elements = [];
  #cleanup = [];

  register(selector) {
    if (typeof selector !== "string") {
      throw new Error(
        '[PhotoSwipeGallery]: expected selector to be of type "string" but received "' +
          typeof selector +
          '"'
      );
    }
    const elements = document.querySelectorAll(selector);
    if (!elements || elements.length === 0) {
      return;
    }

    this.#elements = Array.from(elements);
    this.#cleanup.push(() => {
      this.#elements = [];
    });

    this.#elements.forEach((element) => {
      const children =
        element.children && element.children.length > 0
          ? Array.from(element.children)
          : [];
      if (children.length === 0) {
        return;
      }

      children.forEach((child) => {
        if (!child.tagName) {
          return;
        }

        const img = child.querySelector("img");
        let anchor;
        if (child.tagName.toLowerCase() === "a") {
          anchor = child;
        } else {
          anchor = document.createElement("a");
          child.parentNode.replaceChild(anchor, child);
          anchor.appendChild(child);

          this.#cleanup.push(() => {
            const parent = anchor.parentNode;
            if (parent) {
              parent.replaceChild(child, anchor);
            }
          });
        }

        const href = img ? img.src : "#";
        anchor.href = href;
        if (img) {
          if (href !== "#") {
            const originalImg = new Image();
            originalImg.src = href;
            const updatePwspDimension = () => {
              const imgWidth = originalImg.naturalWidth;
              const imgHeight = originalImg.naturalHeight;
              anchor.setAttribute("data-pswp-width", imgWidth);
              anchor.setAttribute("data-pswp-height", imgHeight);
            };
            originalImg.addEventListener("load", updatePwspDimension);
            this.#cleanup.push(() => {
              originalImg.removeEventListener("load", updatePwspDimension);
              anchor.removeAttribute("data-pswp-width");
              anchor.removeAttribute("data-pswp-height");
            });
          }
          const hasBlankTarget = img.target === "_blank";
          if (!hasBlankTarget) {
            anchor.setAttribute("target", "_blank");
          }

          this.#cleanup.push(() => {
            if (!hasBlankTarget) {
              anchor.removeAttribute("target", "_blank");
            }
          });
        }
      });
    });

    const lightbox = new PhotoSwipeLightbox({
      gallery: selector,
      children: "a",
      pswpModule: () => import("photoswipe"),
    });
    lightbox.init();
    this.#cleanup.push(() => {
      lightbox?.destroy();
    });
  }

  unregister() {
    if (Array.isArray(this.#cleanup) && this.#cleanup.length > 0) {
      this.#cleanup.forEach((cleanup) => {
        if (typeof cleanup === "function") {
          this.#cleanup();
        }
      });
    }
    this.#cleanup = [];

    return this;
  }
}
